module.exports = __webpack_public_path__ + "img/bg.6a46aae6.webp";